import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link
} from '@material-ui/core';
import {
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';

import { PublicNavbar } from '../../components/Navbars';

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      root: {
        margin: '2rem 0'
      }
    }
  }
});

const PrivacyPolicy = () => {
  return (
    <>
      <PublicNavbar />

      <MuiThemeProvider theme={theme}>
        <Container>
          <Box pb={3}>
            <Typography variant="h4" align="center">
              Privacy Policy
            </Typography>
          </Box>
        </Container>
      </MuiThemeProvider>
    </>
  );
};

export default PrivacyPolicy;
